import { toast } from "sonner";

const CHURCH = "Streams of Joy Erith London";
const esc = (s) => String(s ?? "").replace(/[&<>"']/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c]));

export const printQrPoster = (canvas, title, caption, url, steps = []) => {
  if (!canvas) return;
  const img = canvas.toDataURL("image/png");
  const w = window.open("", "_blank");
  if (!w) { toast.error("Please allow pop-ups to print."); return; }
  const stepsHtml = steps.length ? `<ol class="steps">${steps.map((s) => `<li>${esc(s)}</li>`).join("")}</ol>` : "";
  w.document.write(`<!doctype html><html><head><title>${esc(title)} — ${esc(CHURCH)}</title>
    <style>
      *{box-sizing:border-box;font-family:-apple-system,Segoe UI,Roboto,Helvetica,Arial,sans-serif;-webkit-print-color-adjust:exact;print-color-adjust:exact}
      @page{size:A4;margin:0}
      body{margin:0;background:#F1F4F2}
      .poster{width:210mm;min-height:297mm;margin:0 auto;background:#fff;display:flex;flex-direction:column}
      .top{position:relative;overflow:hidden;background:#063B30;color:#fff;padding:56px 56px 64px}
      .top:after{content:"";position:absolute;width:300px;height:300px;right:-80px;top:-120px;border-radius:50%;border:56px solid #2F6B3A}
      .eyebrow{position:relative;z-index:1;color:#F5C518;font-size:15px;font-weight:800;letter-spacing:.16em;text-transform:uppercase}
      h1{position:relative;z-index:1;font-size:46px;line-height:1.08;margin:14px 0 12px;font-weight:800}
      .cap{position:relative;z-index:1;font-size:19px;color:rgba(255,255,255,.88);margin:0;max-width:520px}
      .body{flex:1;display:flex;flex-direction:column;align-items:center;justify-content:center;padding:40px 56px;text-align:center}
      .qr{padding:26px;border-radius:28px;border:5px solid #0B5E4E;background:#fff;box-shadow:0 20px 40px -24px rgba(6,59,48,.5)}
      .qr img{width:330px;height:330px;display:block}
      .scan{margin-top:26px;font-size:24px;font-weight:800;color:#0B5E4E}
      .steps{margin:18px 0 0;padding:0;list-style:none;display:flex;gap:14px;justify-content:center;flex-wrap:wrap}
      .steps li{background:#E3F1EC;color:#063B30;border-radius:999px;padding:8px 16px;font-size:14px;font-weight:600}
      .url{margin-top:18px;font-size:14px;color:#56626A;word-break:break-all}
      .foot{background:#F5C518;color:#063B30;padding:18px 56px;font-size:15px;font-weight:700;display:flex;justify-content:space-between}
    </style></head><body onload="setTimeout(function(){window.print()},250)">
    <div class="poster">
      <div class="top"><div class="eyebrow">${esc(CHURCH)}</div><h1>${esc(title)}</h1><p class="cap">${esc(caption || "")}</p></div>
      <div class="body"><div class="qr"><img src="${img}"/></div><div class="scan">Scan with your phone camera</div>${stepsHtml}<div class="url">${esc(url)}</div></div>
      <div class="foot"><span>${esc(CHURCH)}</span><span>5 Pier Road, Erith DA8 1TA</span></div>
    </div></body></html>`);
  w.document.close();
};
